export const VPN_NOTICE_COOKIE_NAME = 'vpn_notified'
export const VPN_NOTICE_COOKIE_TTL_HOURS = 1
export const RU_COUNTRY_ISO = 'RU'
